import React, { memo } from 'react';

import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import Table from '../../Table';

import ReportService from '../../../services/ReportService';

function UnappliedPaymentsTable() {
  const { t } = useTranslation();

  const { data: unappliedPayments } = useQuery({
    queryKey: ['unappliedPayments'],
    queryFn: ReportService.getUnappliedPayments,
  });

  const cols = [
    {
      title: t('common.tables.columns.Date'),
      keys: ['date'],
      format: (value) => moment(value).format('M/D/YY'),
    },
    {
      title: t('common.tables.columns.Loan'),
      keys: ['_loan._property.address_line_1'],
      link: (row) => `/loans/${row._loan.id}?tab=Property`,
    },
    {
      title: t('common.tables.columns.Borrower'),
      keys: ['doesntmatter'],
      format: (_, row) =>
        row?._loan?._borrower_primary?.TIN_type === 'EIN'
          ? row._loan._borrower_primary?.entity_name
          : `${row._loan._borrower_primary?.first_name} ${row._loan._borrower_primary?.last_name}`,
      link: (row) => `/loans/${row._loan.id}?tab=Borrowers`,
    },
    {
      title: t('common.tables.columns.Amount'),
      keys: ['amount'],
      type: 'currency',
      link: (row) => `/loans/${row._loan.id}/payments/${row.id}?tab=Payment`,
    },
    {
      title: t('common.tables.columns.Amount Applied'),
      keys: ['_total.total_paid'],
      type: 'currency',
    },
    {
      title: t('common.tables.columns.Status'),
      keys: ['status'],
    },
    {
      title: t('common.tables.columns.Source'),
      keys: ['source'],
    },
    {
      title: t('common.tables.columns.Reference'),
      keys: ['reference'],
    },
  ];

  return (
    <Table
      cols={cols}
      rows={unappliedPayments}
      title={t('Dashboard.UnappliedPaymentsTable.Unapplied Payments')}
    />
  );
}

export default memo(UnappliedPaymentsTable);
